// extracted by mini-css-extract-plugin
module.exports = {"link":"ToggleSlidingPane_link__+Ltxm","container":"ToggleSlidingPane_container__cSGlA","img":"ToggleSlidingPane_img__EbbDX"};